/**
 * Vesper Cleo Intros Service (Shared, Sprint 2)
 */

import apiClient from './api.client';

export type CleoIntroStatus = 'pending' | 'accepted' | 'declined' | 'expired';

export interface CleoIntroRecord {
  id: string;
  requesterId: string;
  targetId: string;
  message: string;
  status: CleoIntroStatus;
  createdAt: string;
  respondedAt: string | null;
  conversationId: string | null;
}

export async function createIntro(
  targetId: string,
  message: string,
): Promise<{ intro: CleoIntroRecord; mutual: boolean }> {
  const res = await apiClient.post<{ data: { intro: CleoIntroRecord; mutual: boolean } }>(
    '/cleo/intros',
    { targetId, message },
  );
  return res.data.data;
}

export async function listIntros(): Promise<{ incoming: CleoIntroRecord[]; sent: CleoIntroRecord[] }> {
  const res = await apiClient.get<{ data: { incoming: CleoIntroRecord[]; sent: CleoIntroRecord[] } }>(
    '/cleo/intros',
  );
  return res.data.data;
}
